<template>
  <div
      @click="onClick"
      class="tw-transition tw-grid tw-grid-flow-col tw-gap-4 tw-justify-start tw-items-center tw-p-3 tw--mx-3 tw-group"
      :class="cssClasses.root"
  >
    <!-- Artwork -->
    <div class="tw-w-10 tw-h-10">
      <BaseArtwork class="tw-rounded tw-overflow-hidden" :src="soundkit.image(300)" :active="isActive || isSample"
                   :image-size="300">
        <BasePlay
            v-if="isSample"
            slot="center"
            :size="'small'"
            :playing="isPlaying" />
      </BaseArtwork>
    </div>

    <!-- Title -->
    <div class="tw-font-medium tw-break-all tw-truncate">
      {{ name }}
    </div>
  </div>
</template>
<script>
import BaseArtwork from "../../base/base-artwork";
import BasePlay from "../../base/base-play";
import SoundKit from "../../../models/soundkit";

export default {
  components: { BasePlay, BaseArtwork },
  props: {
    sample: {
      type: SoundKit
    },
    soundkit: {
      type: SoundKit,
      required: true
    },
    name: {
      type: String,
      required: true
    },
    size: {
      type: String
    },
    duration: {
      type: String
    },
    isSample: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    playerActive() {
      return this.$store.state.player.playing;
    },
    playlistManager() {
      return this.$store.state.playlistManager;
    },
    isPlaying() {
      return this.sample && (this.playlistManager.isPlaying(this.sample) && this.playerActive);
    },
    isPaused() {
      return this.sample && (this.playlistManager.isPlaying(this.sample) && !this.playerActive);
    },
    isActive() {
      return this.isPlaying || this.isPaused;
    },
    cssClasses() {
      return {
        root: [
          "tw-text-sm",
          "tw-rounded",
          this.isSample && [
            "tw-cursor-pointer",
            "md:tw-mr-0", // for soundkit page that has a layout of 2 cols (when has a video)
            this.isActive ? [
              "tw-text-infinity-row-active-primary-text",
              "tw-bg-infinity-row-active-background"
            ] : [
              "tw-text-infinity-primary-text",
              "hover:tw-text-infinity-row-hover-primary-text",
              "hover:tw-bg-infinity-row-hover-background"
            ]
          ]
        ]
      };
    }
  },
  methods: {
    onClick() {
      if (!this.isSample)
        return;
      this.isPlaying ? this.sample.pause() : this.sample.play();
    }
  }
};
</script>
